module.exports = __webpack_public_path__ + "img/about.160de5d7.jpg";